import React, { useRef, useState } from "react";
import { Drawer } from "antd";
import { ReactComponent as ArrowLeftIcon } from "../../../assets/images/arrow-left.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/pencil.svg";
import { ReactComponent as RightArrowIcon } from "../../../assets/images/arrow-right-grey.svg";
import { ReactComponent as DirectionIcon } from "../../../assets/images/direction-hr.svg";
import {
  DetailsWrapper,
  BackIconWrapper,
  Wrapper,
  EditIconWrapper,
  DrawerContent,
  SearchSummaryPill,
  FilterIconButton,
} from "./styles";
import { StyledParagraph, StyledTitle } from "../../CustomAntdComponents/Typography";
import RoadSearch from "./RoadSearch";
import { Button, Form } from "antd";
import { useRoadSearchStore } from "../../../store/roadSearch/roadSearchStore";
import { RoadSearchStore } from "../../../store/roadSearch/types";
import { getTerminalName } from "../../TripSummary/helper";
import { useStore } from "../../../store/global/appStore";
import FlightSearchMobile from "../Flight/FlightSearchMobile";
import { MobileDrawerContent } from "../Flight/styles";
import { Tuning2 } from "@solar-icons/react";
import { GREY_12 } from "../../../utils/colors";
import { Pen2 } from "@solar-icons/react";

type Props = {
  navigateHandler: () => void;
  modify: boolean;
  refetchSearch: () => void;
  onModifyChange: (value: boolean) => void;
  onOpenFilters?: () => void;
};
function MobileHeader({ navigateHandler, modify, onModifyChange, refetchSearch, onOpenFilters }: Props) {
  const drawerContainerRef = useRef(null);
  const { formData, updateFormData } = useRoadSearchStore();
  const { roadRoutes } = useStore();
  const [form] = Form.useForm();

  const { DepartureDate, ArrivalDate, ArrivalId, DepartureId, TripType } = formData;

  const isRoundTrip = TripType === "round_trip";
  const departure = getTerminalName(roadRoutes, DepartureId);
  const arrival = getTerminalName(roadRoutes, ArrivalId);
  const [payload, setPayload] = useState<RoadSearchStore>(formData);

  const handleSubmit = () => {
    form
      .validateFields()
      .then(() => {
        updateFormData(payload);
        onModifyChange(false);
        refetchSearch();
      })
      .catch(() => {});
  };

  const handleChange = (object) => {
    setPayload({ ...payload, ...object });
    form.setFieldsValue(object);
  };

  const DrawerFooter = (
    <Button type="primary" block onClick={handleSubmit}>
      Search Bus
    </Button>
  );

  return (
    <>
      <div ref={drawerContainerRef} style={{ background: "#fff", padding: "16px 20px 0 20px" }}>
        <Wrapper
          style={{
            paddingTop: "10px",
            paddingLeft: 0,
            paddingRight: 0,
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <BackIconWrapper onClick={navigateHandler}>
            <ArrowLeftIcon width={20} height={20} />
          </BackIconWrapper>
          <SearchSummaryPill onClick={() => onModifyChange(true)}>
            <div>
              <DetailsWrapper>
                <StyledTitle level={5}>{departure}</StyledTitle>

                {isRoundTrip ? <DirectionIcon /> : <RightArrowIcon />}

                <StyledTitle level={5}>{arrival}</StyledTitle>
              </DetailsWrapper>

              <StyledParagraph color={GREY_12}>
                <span>
                  {isRoundTrip && arrival
                    ? `${DepartureDate.format("ddd, MMM D")} - ${ArrivalDate.format("ddd, MMM D")}`
                    : DepartureDate.format("ddd, MMM D")}
                </span>
              </StyledParagraph>
            </div>

            <EditIconWrapper
              onClick={(e) => {
                e.stopPropagation();
                onModifyChange(true);
              }}
            >
              <Pen2 weight="Outline" size={20} />
            </EditIconWrapper>
          </SearchSummaryPill>

          <FilterIconButton onClick={onOpenFilters}>
            <Tuning2 weight="Bold" size={20} color={GREY_12} />
          </FilterIconButton>
        </Wrapper>
      </div>

      <Drawer
        open={modify}
        onClose={() => onModifyChange(false)}
        footer={DrawerFooter}
        title={"Modify search"}
        placement="bottom"
        height="100%"
        getContainer={drawerContainerRef.current as HTMLElement}
      >
        <MobileDrawerContent>
          <RoadSearch onSubmit={handleSubmit} onChange={handleChange} payload={payload} form={form} />
        </MobileDrawerContent>
      </Drawer>
    </>
  );
}

MobileHeader.defaultProps = {
  name: undefined,
  navigateHandler: undefined,
};

export default MobileHeader;
